import { render, staticRenderFns } from "./AdminRequestPage.vue?vue&type=template&id=19fc7a32&"
import script from "./AdminRequestPage.vue?vue&type=script&lang=js&"
export * from "./AdminRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports